import type { Organization } from "@/models/organization"
import { useRenameQueryResult } from "@/services/utils"

import { useCredentials } from "./use-credentials"

interface UseCredentialOptions {
  credentialId: string | null | undefined
  organizationId: Organization["id"]
}

/**
 * Resolves one credential from the org credentials list meta by id.
 * There is no Pipelines GET-by-id; list meta is the read model for show/edit.
 *
 * Admin show/edit should use `useAdminCredentialPageState` so list
 * `placeholderData: []` does not false-404.
 */
export const useCredential = ({
  credentialId,
  organizationId,
}: UseCredentialOptions) => {
  const {
    credentialsData,
    credentialsError,
    credentialsIsFetched,
    credentialsIsLoading,
    credentialsIsPlaceholderData,
  } = useCredentials({ organizationId })

  const data =
    credentialId == null || credentialId === ""
      ? undefined
      : credentialsData?.find((credential) => credential.id === credentialId)

  const isLoading =
    Boolean(organizationId) &&
    (credentialsIsLoading ||
      (!credentialsIsFetched && credentialId != null && credentialId !== ""))

  return useRenameQueryResult(
    {
      data,
      error: credentialsError,
      isFetched: credentialsIsFetched,
      isLoading,
      isPlaceholderData: credentialsIsPlaceholderData,
    },
    "credential"
  )
}
